import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import AboutMePage from './pages/AboutMePage';
import Bloglist from './pages/Bloglist';
import Blog from './pages/Blog';
import NotFound from './pages/NotFound';

const App: React.FC = () => {
    return (
        <Router>
            <div className="min-h-screen bg-terminal-background text-terminal-text">
                <Navbar />
                <div className="container mx-auto p-20">
                    <Routes>
                        <Route path="/" element={<AboutMePage />} />
                        <Route path="/blogs" element={<Bloglist />} />
                        <Route path="/blogs/:slug" element={<Blog />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
                <Footer />
            </div>
        </Router>
    );
};

export default App;

